<script setup>
// Components

import { router, usePage } from "@inertiajs/vue3";
// Composables
import { useDisplay } from "vuetify";

// Utilities

import { onBeforeUnmount, onMounted, ref, inject, watch } from "vue";
import { watchDebounced } from "@vueuse/core";
import { useThemeSetting } from "@/Composable/ThemeSetting";
import usersSearchCard from "@/Components/Cards/UsersSearchCard.vue";
import sectionsSearchCard from "@/Components/Cards/SectionsSearchCard.vue";
import ProductSearchCard from "@/Components/Cards/ProductSearchCard.vue";
import postsSearchCard from "@/Components/Cards/PostsSearchCard.vue";
import ProductCard from "@/Components/Cards/ProductCard.vue";

import debounce from "lodash.debounce";
import { computed } from "vue";

// Types

const q = computed(() => route().params?.q);
const { isDark } = useThemeSetting();

const __t = inject("__t");
const form = ref({
    search: q.value || "",
});
const results = ref([]);
const countResults = ref(0);
const loading = ref(false);
const withid = ref(null);
const search = debounce(() => {
    if (form.value.search) {
        loading.value = true;
        axios.get(route("api.searchAll", { q: form.value.search }))
            .then((res) => {
                results.value = res.data.results;
                countResults.value = res.data.count;
            })
            .finally(() => (loading.value = false));
    }

    // model.value = false;
}, 800);
const { smAndUp, mdAndUp, xs, lgAndUp, mdAndDown } = useDisplay();

const model = ref(false);
const searchString = ref("");

const locale = "en";

onMounted(() => {
    // if is not ssr
    if (typeof window !== "undefined") {
        document.addEventListener("keydown", onDocumentKeydown);
    }
});
onBeforeUnmount(() => {
    if (typeof window !== "undefined") {
        document.removeEventListener("keydown", onDocumentKeydown);
    }
});

watch(
    () => form.value.search,
    () => {
        search();
        // if search is empty reset the results
        if (!form.value.search) {
            results.value = [];
            countResults.value = 0;
        }
    },
    {
        immediate: true,
    }
);
function onDocumentKeydown(e) {
    if (!model.value && e.key === "/") {
        let $typeE = e.target.tagName.toLowerCase();
        if ($typeE == "input" || $typeE == "textarea" || $typeE == "select") return;
        e.preventDefault();

        model.value = true;
    } else if (model.value && ["ArrowDown", "ArrowUp"].includes(e.key)) {
        //   list.value?.rootEl?.focus()
    }
}

function getComponent(index) {
    switch (index) {
        case "users":
            return usersSearchCard;
        case "sections":
            return sectionsSearchCard;
        case "categories":
            return sectionsSearchCard;
        case "posts":
            return postsSearchCard;
        case "products":
            return sectionsSearchCard;
        default:
            return "div";
    }
}
</script>

<template>
    <v-dialog v-model="model" scrollable width="1200" class="h-full " @after-leave="form.search = ''">
        <template #activator="{ props }">

            <!-- <v-text-field ref="withid" clearable :label="__t('search')" :placeholder="__t('search')" v-bind="props"
        class="flex-grow-0 w-full " v-if="mdAndUp" density="comfortable" hide-details append-inner-icon="mdi-magnify" /> -->




            <v-btn class="text-center mx-9 " variant="text" :active="model" icon="mdi-magnify"
                prepend-icon="mdi-magnify" v-bind="props">
                <v-icon icon="mdi-magnify"></v-icon>
                <span class="flex items-center justify-between align-center">
                    <span>
                        <!-- {{ __t("search") }} -->
                    </span>

                    <!-- <span :class="[
            mdAndDown ? 'border-opacity-0' : 'py-1 px-2 ms-2',
            'border rounded text-disabled text-caption',
          ]">
            <span>{{ __t("press") }} /</span>
          </span> -->
                </span>
            </v-btn>


        </template>
        <v-card height="100%">
            <v-card-title class="justify-between py-4 shadow-md bg-primar y d-flex align-center bg-surface">
                <div class="mx-3">
                    {{ __t("search") }}
                </div>
                <v-btn prepend-icon="mdi-close" :text="__t('close')" variant="outlined" @click="model = false"></v-btn>
                <!-- <v-spacer /> -->
            </v-card-title>

            <v-card-text class="pa-4">
                <v-row>
                    <v-col cols="12" md="4">
                        <div class="flex flex-col items-center justify-center p-4">
                            <v-text-field :loading="loading" ref="withid" clearable v-model="form.search"
                                :label="__t('search')" :placeholder="__t('search')" autofocus
                                class="flex-grow-0 w-full mx-2 md:mt-32" density="comfortable" hide-details
                                prepend-inner-icon="mdi-magnify" @keyup.enter="search" />
                            <br />
                            <div class="flex justify-end w-full">
                                <v-btn @click.prevent="search" class="px-9">{{ __t("search") }}</v-btn>

                            </div>

                        </div>
                    </v-col>
                    <v-col cols="12" md="8" v-if="!form.search && !countResults">
                        <div class="flex items-center justify-center" v-if="!countResults">
                            <div class="flex flex-col items-center justify-center my-10">
                                <v-img src="/assets/svg/39.svg" class="h-64 opacity-90 w-72 dark:dark-img-note"
                                    :class="isDark ? 'dark-img-note' : ''"></v-img>
                                <div class="mt-2 text-primary font-bold text-center text-[16px]">
                                    {{ __t("search_des") }}
                                </div>
                                <!-- <v-progress-linear v-if="loading" color="primary" indeterminate></v-progress-linear> -->
                                <div class="mt-2 text-center text-[14px]">
                                    {{ __t("search_des1") }}

                                    <br />
                                    <!-- {{ __t("search_des2") }} -->
                                </div>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" md="8" v-if="form.search && form.search.length > 0 && !countResults">
                        <div class="flex items-center justify-center" v-if="!countResults">
                            <div class="flex flex-col items-center justify-center my-10">
                                <v-img src="/assets/svg/38.svg" class="h-64 opacity-90 w-72 dark:dark-img-note"
                                    :class="isDark ? 'dark-img-note' : ''"></v-img>
                                <div class="mt-2 text-primary font-bold text-center text-[16px]">
                                    {{ __t("search_des") }}
                                </div>
                                <v-progress-linear v-if="loading" color="primary" class="mt-5"
                                    indeterminate></v-progress-linear>
                                <div class="mt-2 text-center text-[14px]" v-else>
                                    {{ __t("search_des_no_result") }}
                                    <br />
                                    <!-- {{ __t("search_des2") }} -->
                                </div>
                            </div>
                        </div>
                    </v-col>


                    <v-col cols="12" md="8" v-if="countResults">


                        <div class="min-h-[400px]">
                            <div class="mt-3">
                                <p class="mb-4 font-bold">
                                    {{ __t("results") }} : {{ countResults }}
                                </p>
                                <!-- <hr> -->
                            </div>
                            <div v-for="(item, index) in results" :key="index">
                                <div class="mt-3">
                                    <p class="mb-4">{{ __t(index) }}</p>
                                    <hr />
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="4" v-for="(v, k) in item" :key="k">
                                            <component @click="model = false" :is="getComponent(index)" :item="v" />
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>


<style scoped>
:deep(.v-field--variant-solo) {
    box-shadow: none;
}

.dark-img-note {
    filter: invert(100%) sepia(3%) saturate(0%) hue-rotate(321deg) brightness(107%) contrast(104%);
}
</style>
